<!--消控室-->
<template>
  <el-dialog
      :visible="visible"
      :showClose="false"
      :modal="false"
      lock-scroll
      style="position: absolute"
  >
    <!-- 火灾报警控制器展开 -->
    <div class="firescreen" v-if="parameter.fireAlarm">
      <img :src="zoomOutImg" class="zoomOut" @click="onClose" />
      <div class="buttons">
        <div
            id="fone"
            class="button"
            style="background: rgb(51, 148, 243); color: rgb(255, 255, 255)"
            @click="buttonSelect('f1')"
        >
          F1
        </div>
        <div
            id="ftwo"
            class="button"
            style="background: rgb(51, 148, 243); color: rgb(255, 255, 255)"
            @click="buttonSelect('f2')"
        >
          F2
        </div>
        <div
            id="fthree"
            class="button"
            style="background: rgb(51, 148, 243); color: rgb(255, 255, 255)"
            @click="buttonSelect('f3')"
        >
          F3
        </div>
        <div
            id="ffour"
            class="button"
            style="background: rgb(51, 148, 243); color: rgb(255, 255, 255)"
            @click="buttonSelect('f4')"
        >
          F4
        </div>
        <div
            id="ffive"
            class="button"
            style="background: rgb(51, 148, 243); color: rgb(255, 255, 255)"
            @click="buttonSelect('f5')"
        >
          F5
        </div>
        <div
            id="fsix"
            class="button"
            style="background: rgb(51, 148, 243); color: rgb(255, 255, 255)"
            @click="buttonSelect('f6')"
        >
          F6
        </div>
        <div
            id="maual"
            class="button"
            style="background: rgb(51, 148, 243); color: rgb(255, 255, 255)"
            @click="buttonSelect('handTurn')"
        >
          手动切换
        </div>
        <div
            id="one"
            class="button"
            style="background: rgb(51, 148, 243); color: rgb(255, 255, 255)"
            @click="buttonSelect('one')"
        >
          1
        </div>
        <div
            id="two"
            class="button"
            style="background: rgb(51, 148, 243); color: rgb(255, 255, 255)"
            @click="buttonSelect('two')"
        >
          2
        </div>
        <div
            id="three"
            class="button"
            style="background: rgb(51, 148, 243); color: rgb(255, 255, 255)"
        >
          3
        </div>
        <div
            id="func"
            class="button"
            style="background: rgb(51, 148, 243); color: rgb(255, 255, 255)"
            @click="buttonSelect('func')"
        >
          功能
        </div>
        <div
            id="up"
            class="button"
            style="background: rgb(251, 148, 54); color: rgb(255, 255, 255)"
        >
          ▲
        </div>
        <div
            id="cancel"
            class="button"
            style="background: rgb(51, 148, 243); color: rgb(255, 255, 255)"
        >
          取消
        </div>
        <div
            id="auto"
            class="button"
            style="background: rgb(51, 148, 243); color: rgb(255, 255, 255)"
            @click="buttonSelect('auto')"
        >
          自动切换
        </div>
        <div
            id="four"
            class="button"
            style="background: rgb(51, 148, 243); color: rgb(255, 255, 255)"
        >
          4
        </div>
        <div
            id="five"
            class="button"
            style="background: rgb(51, 148, 243); color: rgb(255, 255, 255)"
        >
          5
        </div>
        <div
            id="six"
            class="button"
            style="background: rgb(51, 148, 243); color: rgb(255, 255, 255)"
        >
          6
        </div>
        <div
            id="left"
            class="button"
            style="background: rgb(251, 148, 54); color: rgb(255, 255, 255)"
        >
          ◀︎
        </div>
        <div
            id="confirm"
            class="button"
            style="background: rgb(51, 148, 243); color: rgb(255, 255, 255)"
            @click="buttonSelect('confirm')"
        >
          确定
        </div>
        <div
            id="right"
            class="button"
            style="background: rgb(251, 148, 54); color: rgb(255, 255, 255)"
        >
          ▶︎
        </div>
        <div
            id="reset"
            class="button"
            style="background: rgb(252, 52, 56); color: rgb(255, 255, 255)" @click="buttonSelect('reset')"
        >
          复位
        </div>
        <div
            id="seven"
            class="button"
            style="background: rgb(51, 148, 243); color: rgb(255, 255, 255)"
        >
          7
        </div>
        <div
            id="eight"
            class="button"
            style="background: rgb(51, 148, 243); color: rgb(255, 255, 255)"
        >
          8
        </div>
        <div
            id="nine"
            class="button"
            style="background: rgb(51, 148, 243); color: rgb(255, 255, 255)"
        >
          9
        </div>
        <div
            id="lang"
            class="button"
            style="background: rgb(51, 148, 243); color: rgb(255, 255, 255)"
        >
          中/英
        </div>
        <div
            id="down"
            class="button"
            style="background: rgb(251, 148, 54); color: rgb(255, 255, 255)"
        >
          ▼
        </div>
        <div
            id="custom"
            class="button"
            style="background: rgb(51, 148, 243); color: rgb(255, 255, 255)"
        >
          自定义
        </div>
        <div
            id="check"
            class="button"
            style="background: rgb(41, 203, 128); color: rgb(255, 255, 255)"
        >
          自检
        </div>
        <div
            id="point"
            class="button"
            style="background: rgb(51, 148, 243); color: rgb(255, 255, 255)"
        >
          ・
        </div>
        <div
            id="zero"
            class="button"
            style="background: rgb(51, 148, 243); color: rgb(255, 255, 255)"
            @click="buttonSelect('zero')"
        >
          0
        </div>
        <div
            id="equal"
            class="button"
            style="background: rgb(51, 148, 243); color: rgb(255, 255, 255)"
        >
          # =
        </div>
        <div
            id="sg"
            class="button"
            style="background: rgb(51, 148, 243); color: rgb(255, 255, 255)"
        >
          声光启
        </div>
        <div
            id="sg1"
            class="button"
            style="background: rgb(51, 148, 243); color: rgb(255, 255, 255)"
        >
          声光停
        </div>
        <div
            id="ld"
            class="button"
            style="background: rgb(51, 148, 243); color: rgb(255, 255, 255)"
        >
          联动
        </div>
        <div
            id="mute"
            class="button"
            style="background: rgb(252, 52, 56); color: rgb(255, 255, 255)"
        >
          消音
        </div>
      </div>
      <div class="light">
        <div class="left">
          <div class="item">
            <span class="grey" :class="parameter['light']&&parameter['light']['automatic']"></span>
            <span>自动方式</span>
          </div>
          <div class="item" style="margin-bottom: 0px">
            <span class="grey" :class="parameter['light']&&parameter['light']['handStart']"></span>
            <span>手动方式</span>
          </div>
        </div>
        <!-- 按钮状态 红 橙 绿 -->
        <div class="right">
          <div class="item" style="margin-bottom: 1.875rem">
            <span class="grey" :class="parameter['light']&&parameter['light']['fire']"></span>
            <span style="font-size: 1.5rem; height: 2rem">火警</span>
          </div>
          <div class="item" style="margin-bottom: 1.875rem">
            <span class="grey" :class="parameter['light']&&parameter['light']['start']"></span>
            <span style="font-size: 1.5rem; height: 2rem">启动</span>
          </div>
          <div class="item">
            <span class="grey" :class="parameter['light']&&parameter['light']['supervise']"></span>
            <span>监管报警</span>
          </div>
          <div class="item">
            <span class="grey" :class="parameter['light']&&parameter['light']['fault']"></span>
            <span>故障</span>
          </div>
          <div class="item">
            <span class="grey" :class="parameter['light']&&parameter['light']['delayed']"></span>
            <span>启动延时</span>
          </div>
          <div class="item">
            <span class="grey" :class="parameter['light']&&parameter['light']['feedback']"></span>
            <span>反馈</span>
          </div>
          <div class="item">
            <span class="grey" :class="parameter['light']&&parameter['light']['manualAlarm']"></span>
            <span>手动报警</span>
          </div>
          <div class="item">
            <span class="grey" :class="parameter['light']&&parameter['light']['shield']"></span>
            <span>屏蔽</span>
          </div>
          <div class="item">
            <span class="grey" :class="parameter['light']&&parameter['light']['systemFailure']"></span>
            <span>系统故障</span>
          </div>
          <div class="item">
            <span class="grey" :class="parameter['light']&&parameter['light']['mute']"></span>
            <span>消音</span>
          </div>
          <div class="item">
            <span class="grey" :class="parameter['light']&&parameter['light']['run']"></span>
            <span>运行</span>
          </div>
          <div class="item">
            <span class="grey" :class="parameter['light']&&parameter['light']['selfTest']"></span>
            <span>自检</span>
          </div>
          <div class="item">
            <span class="grey" :class="parameter['light']&&parameter['light']['mainElectricity']"></span>
            <span>主电运行</span>
          </div>
          <div class="item">
            <span class="grey" :class="parameter['light']&&parameter['light']['backupPower']"></span>
            <span>备电运行</span>
          </div>
          <div class="item" style="margin-bottom: 0px">
            <span class="grey" :class="parameter['light']&&parameter['light']['mainElectricityBug']"></span>
            <span>主电故障</span>
          </div>
          <div class="item" style="margin-bottom: 0px">
            <span class="grey" :class="parameter['light']&&parameter['light']['backupPowerBug']"></span>
            <span>备电故障</span>
          </div>
        </div>
      </div>
      <div class="time">
        <div class="crayon-clock" style="font-family: Digit; color: red">
          <!---->
          <div class="crayon-clock-time" style="font-size: 2.625rem;font-family: electronicFont;">{{HI}}</div>
        </div>
      </div>
      <div class="show">
        <!-- 屏幕内容 -->
        <div class="inner">
          <div class="left">
            <div class="title"><span v-if="parameter[keyCode]&&parameter[keyCode].show&&parameter[keyCode].title">{{ parameter[keyCode].title}}</span></div>
            <div class="enter" v-if="parameter[keyCode]&&parameter[keyCode]['show']&&parameter[keyCode]['enter']">
              <span style="margin-right: 6rem" v-if="parameter[keyCode]['enter']['hui']">{{ parameter[keyCode]['enter']['hui'] }}回路</span>
              <span style="margin-right: 6rem" v-if="parameter[keyCode]['enter']['dizhi']">{{ parameter[keyCode]['enter']['dizhi'] }}地址</span>
              <span v-if="parameter[keyCode]['enter']['jizi']">{{ parameter[keyCode]['enter']['jizi'] }}机</span>

            </div>
            <div class="result" v-if="parameter[keyCode]&&parameter[keyCode]['show']&&parameter[keyCode]['result']">
              <div class="row" v-for="item in parameter[keyCode]['result']" style="margin-top: 0"><span class="cell" style="font-size: 0.7rem">{{item}}</span></div>
            </div>
            <div class="qita" v-else>
              <!-- 屏幕信息 -->
              <div class="main" v-if="parameter[keyCode]&&parameter[keyCode].show">
                <div
                    class="row"
                    v-for="(item, index) in parameter[keyCode]['fireAlarm']"
                    :key="index"
                >
                  <div class="cell" style="min-width: 2.5rem" v-if="item['num']">
                    {{ item["num"] }}
                  </div>
                  <div class="cell" style="min-width: 7.5rem" v-if="!item['YMDHI']">{{ YMDHI }}</div>
                  <div
                      class="cell"
                      style="min-width: 1.375rem"
                      v-if="item['addresCode']"
                  >
                    {{ item["addresCode"] }}
                  </div>
                  <div class="cell" v-if="item['addres']">
                    {{ item["addres"] }}
                  </div>
                </div>
              </div>
              <div class="title linkage" v-if="parameter[keyCode] &&parameter[keyCode].show && parameter[keyCode]['linkage']" v-html="parameter[keyCode]['linkage']['tips']"></div>
              <div class="main linkage" v-show="!parameter[keyCode]||(parameter[keyCode]&&!parameter[keyCode].show)">
                <div class="init">正常监控状态</div>
              </div>
            </div>
          </div>
          <div class="right">
            <div class="content">
              <div class="basic" >{{(parameter.right && parameter.right.zhengchang)?(parameter.right.zhengchang):'正常：运行'}}</div>
              <div class="basic">{{(parameter.right && parameter.right.shoudong)?(parameter.right.shoudong):'手动：允许'}}</div>
              <div class="basic">{{(parameter.right && parameter.right.zidong)?(parameter.right.zidong):'自动：禁止'}}</div>
              <div class="basic bg">{{(parameter.right && parameter.right.shengguangu)?(parameter.right.shengguangu):'声光故障：000'}}</div>
              <div class="basic bg">{{(parameter.right && parameter.right.shengguanping)?(parameter.right.shengguanping):'声光屏蔽：000'}}</div>
              <div class="basic">{{(parameter.right && parameter.right.quanxian)?(parameter.right.quanxian):'用户权限：0'}}</div>
            </div>
            <div class="timer">
              <div
                  class="crayon-clock"
                  style="font-family: 宋体; color: rgb(255, 255, 255)"
              >
                <div class="crayon-clock-date">
                  <span class="date" style="font-size: 12px">{{YMD}}</span>
                  <!---->
                </div>
                <div class="crayon-clock-time" style="font-size: 12px">{{HIS}}</div>
              </div>
            </div>
          </div>

          <div class="menu" v-if="parameter.menu&&parameter.menu.length>0">
            <div class="menu-f" v-for="item in parameter.menu">{{ item }}</div>
          </div>
          <div class="menu" v-else>
            <div class="menu-f">F1查火警</div>
            <div class="menu-f">F2查启动</div>
            <div class="menu-f">F3查故障</div>
            <div class="menu-f">F4查监管</div>
            <div class="menu-f">F5查屏蔽</div>
            <div class="menu-f">F6查反馈</div>
          </div>
        </div>
      </div>
      <div class="print">
        <div class="paper">
          <div class="zoom" v-if="parameter.print">
            <img src="../../../assets/img/zoomIn.png" @click="show" />
          </div>
        </div>
      </div>

      <!-- 弹出纸 -->
      <div
          class="print-paper"
          :class="{
          hiden: !isShow,
        }"
          v-if="parameter.print"
      >
        <img
            :src="zoomOutImg"
            class="hidepaper"
            @click="isShow = false"
        />
        <div class="print-list">
          <div v-if="parameter.f1 && parameter.f1.fireAlarm &&parameter.f1.show">
            <div
                class="print-item"
                v-for="(item, index) in parameter.f1.fireAlarm"
                :key="index"
            >
              {{ item.num }} {{YMDHI}} {{item.addresCode}} {{ item.addres }}
            </div>

          </div>
          <div v-if="parameter.f2 && parameter.f2.fireAlarm &&parameter.f2.show">
            <div
                class="print-item"
                v-for="(item, index) in parameter.f2.fireAlarm"
                :key="index"
            >
              {{ item.num }} {{YMDHI}} {{item.addresCode}} {{ item.addres }}
            </div>

          </div>
          <div v-if="parameter.f3 && parameter.f3.fireAlarm &&parameter.f3.show">
            <div
                class="print-item"
                v-for="(item, index) in parameter.f3.fireAlarm"
                :key="index"
            >
              {{ item.num }} {{YMDHI}} {{item.addresCode}} {{ item.addres }}
            </div>

          </div>
          <div v-if="parameter.f4 &&parameter.f4.show && parameter.f4.fireAlarm">
            <div
                class="print-item"
                v-for="(item, index) in parameter.f4.fireAlarm"
                :key="index"
            >
              {{ item.num }} {{YMDHI}} {{item.addresCode}} {{ item.addres }}
            </div>

          </div>
          <div v-if="parameter.f5 &&parameter.f5.show && parameter.f5.fireAlarm">
            <div
                class="print-item"
                v-for="(item, index) in parameter.f5.fireAlarm"
                :key="index"
            >
              {{ item.num }} {{YMDHI}} {{item.addresCode}} {{ item.addres }}
            </div>

          </div>
          <div v-if="parameter.f6 &&parameter.f6.show && parameter.f6.fireAlarm">
            <div
                class="print-item"
                v-for="(item, index) in parameter.f6.fireAlarm"
                :key="index"
            >
              {{ item.num }} {{YMDHI}} {{item.addresCode}} {{ item.addres }}
            </div>

          </div>
          <div v-if="parameter.ff &&parameter.ff.show && parameter.ff.fireAlarm">
            <div
                class="print-item"
                v-for="(item, index) in parameter.ff.fireAlarm"
                :key="index"
            >
              {{ item.num }} {{YMDHI}} {{item.addresCode}} {{ item.addres }}
            </div>

          </div>
        </div>
      </div>
      <!---->
    </div>
<!--      消防联动控制器-->
    <div v-if="parameter.fireLinkage">
<!--      <div>消防联动图</div>-->
      <div class="bus">
        <img :src="zoomOutImg" class="zoomOut" @click="onClose" />
        <div class="lights">
          <div class="start"><span :class="parameter.yunxing?parameter.yunxing:'grey'"></span><span>运行</span></div>
          <div class="type">
            <span class="maual">手动方式</span>
            <div class="mlight" style="margin-bottom: 20px">
              <span class="red" :class="parameter.jinzhi?parameter.jinzhi:'grey'"></span><span>禁止</span>
            </div>
            <div class="mlight"><span :class="parameter.yunxv?parameter.yunxv:'grey'"></span><span>允许</span></div>
          </div>
        </div>
        <div class="operate">
          <div class="head">
            <div class="th">
              <div>动作</div>
              <div>反馈</div>
              <div>操作</div>
              <div>受控设备</div>
            </div>
            <div class="th">
              <div>动作</div>
              <div>反馈</div>
              <div>操作</div>
              <div>受控设备</div>
            </div>
            <div class="th">
              <div>动作</div>
              <div>反馈</div>
              <div>操作</div>
              <div>受控设备</div>
            </div>
            <div class="th">
              <div>动作</div>
              <div>反馈</div>
              <div>操作</div>
              <div>受控设备</div>
            </div>
            <div class="th">
              <div>动作</div>
              <div>反馈</div>
              <div>操作</div>
              <div>受控设备</div>
            </div>
            <div class="th">
              <div>动作</div>
              <div>反馈</div>
              <div>操作</div>
              <div>受控设备</div>
            </div>
          </div>
          <div class="list">
            <div class="parent">
              <div class="child">
                <div class="row">
                  <div class="light" :class="parameter.jvanA1?parameter.jvanA1:'grey'"></div>
                  <div class="light" :class="parameter.jvanA2?parameter.jvanA2:'grey'"></div>
                  <div class="button"></div>
                  <div class="text">A区防火卷帘</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light" :class="parameter.xiaofangti1?parameter.xiaofangti1:'grey'"></div>
                  <div class="light" :class="parameter.xiaofangti2?parameter.xiaofangti2:'grey'"></div>
                  <div class="button"></div>
                  <div class="text">消防电梯</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light" :class="parameter.paiyan1?parameter.paiyan1:'grey'"></div>
                  <div class="light" :class="parameter.paiyan2?parameter.paiyan2:'grey'"></div>
                  <div class="button"></div>
                  <div class="text">排烟阀</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light" :class="parameter.qiansongfeng1?parameter.qiansongfeng1:'grey'"></div>
                  <div class="light" :class="parameter.qiansongfeng2?parameter.qiansongfeng2:'grey'"></div>
                  <div class="button"></div>
                  <div class="text">前室送风口</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light" :class="parameter.songfeng1?parameter.songfeng1:'grey'"></div>
                  <div class="light" :class="parameter.songfeng2?parameter.songfeng2:'grey'"></div>
                  <div class="button"></div>
                  <div class="text">送风口</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">电动排烟窗</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">挡烟垂壁</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light" :class="parameter.paiyankou1?parameter.paiyankou1:'grey'"></div>
                  <div class="light" :class="parameter.paiyankou2?parameter.paiyankou2:'grey'"></div>
                  <div class="button"></div>
                  <div class="text">排烟口</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">9</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">10</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">11</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">12</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">13</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">14</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">15</div>
                </div>
              </div>
            </div>
            <div class="parent">
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">16</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">17</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">18</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">19</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">20</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">21</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">22</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">23</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">24</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">25</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">26</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">27</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">28</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">29</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">30</div>
                </div>
              </div>
            </div>
            <div class="parent">
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">31</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">32</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">33</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">34</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">35</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">36</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">37</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">38</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">39</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">40</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">41</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">42</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">43</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">44</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">45</div>
                </div>
              </div>
            </div>
            <div class="parent">
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">46</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">47</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">48</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">49</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">50</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">51</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">52</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">53</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">54</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">55</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">56</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">57</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">58</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">59</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">60</div>
                </div>
              </div>
            </div>
            <div class="parent">
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">61</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">62</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">63</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">64</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">65</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">66</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">67</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">68</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">69</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">70</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">71</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">72</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">73</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">74</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">75</div>
                </div>
              </div>
            </div>
            <div class="parent">
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">76</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">77</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">78</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">79</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">80</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">81</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">82</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">83</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">84</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">85</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">86</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">87</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">88</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">89</div>
                </div>
              </div>
              <div class="child">
                <div class="row">
                  <div class="light grey"></div>
                  <div class="light grey"></div>
                  <div class="button"></div>
                  <div class="text">90</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
<!--    广播-->
    <div v-if="parameter.broadcast">
      <div class="broadcast" scence-idx="0">
        <img :src="zoomOutImg" class="zoomOut" @click="onClose"/>
        <div  class="top">
          <div  class="tel">
            <div  class="tel-bottom"><div  class="phone" :class="parameter.telPhone" @click="buttonSelect('bphone')"></div>
            </div>
          </div>
          <div  class="dial">
            <div  class="left">
              <div  class="screen">

                <div class="enter"  v-if="parameter.enter">
                  <span>输入密码</span><span class="password" ref="broadPassword">{{parameter.broadPassword}}</span>
                </div>
                <div class="menu" v-else-if="parameter.menu">
                  <div>主菜单</div>
                  <div class="menu-box">
                    <span>【自检】</span><span>【设置】</span><span>【查询】</span><span>【放音】</span>
                  </div>
                </div>
                <div class="fault" v-else-if="parameter.fault">
                  <span>故障</span><span>{{parameter.faultMsg}}</span>
                </div>
                <div class="ready" v-else-if="parameter.ready">
                  <span>已准备好 请呼叫</span>
                </div>
                <div class="hujiao" v-else-if="parameter.hujiao">
                  <span>通话：</span>
                  <span>总：0</span>
                  <span>呼入：</span>
                  <span>总：0</span>
                  <span>呼出：{{parameter.huchu?parameter.huchu:''}}</span>
                  <span>总：{{parameter.zong?parameter.zong:0}}</span>
                  <span>号码输入：{{parameter.hujiaoNum}}</span>
                </div>
                <div v-else>
                  <div  class="sclock">
                    <div class="week">
                      <div class="datetime">
                        <div class="date">日期：{{reDate()}}</div>
                        <div class="time">时间：{{HIS}}</div>
                      </div><!---->
                    </div>
                  </div>
                  <div  class="systemstate">系统正常运行</div>
                </div>
              </div>
              <div  class="buttons">
                <div  class="btn" @click="buttonSelect('bb1')"><span ></span><span>▲</span></div>
                <div  class="btn" @click="buttonSelect('bb2')"><span ></span><span>确认/放音</span></div>
                <div  class="btn" @click="buttonSelect('bb3')"><span ></span><span>复位</span></div>
                <div  class="btn" @click="buttonSelect('bb4')"><span ></span><span >▼</span></div>
                <div  class="btn" @click="buttonSelect('bb5')"><span ></span><span >查询/返回</span></div>
                <div  class="btn" @click="buttonSelect('bb6')"><span ></span><span >消音</span></div>
              </div>
            </div>
            <div  class="right">
              <div  class="lights">
                <div  class="light"><span  class="l grey" :class="parameter.rightlist&&parameter.rightlist.light1"></span><span >呼叫</span></div>
                <div  class="light"><span  class="l grey" :class="parameter.rightlist&&parameter.rightlist.light2"></span><span >通话</span></div>
                <div  class="light"><span  class="l grey" :class="parameter.rightlist&&parameter.rightlist.light3"></span><span >故障</span></div>
                <div  class="light"><span  class="l grey" :class="parameter.rightlist&&parameter.rightlist.light4"></span><span >工作</span></div>
                <div  class="light"><span  class="l grey" :class="parameter.rightlist&&parameter.rightlist.light5"></span><span >录音</span></div>
                <div  class="light"><span  class="l grey" :class="parameter.rightlist&&parameter.rightlist.light6"></span><span >录音满</span></div>
                <div  class="light"><span  class="l grey" :class="parameter.rightlist&&parameter.rightlist.light7"></span><span >消音</span></div>
              </div>
              <div  class="nums">
                <div  v-for="index in 9" class="num"><span @click="buttonSelect('bn'+index)"></span><span>{{index}}</span></div>
                <div  class="num" @click="buttonSelect('bnjt')"><span></span><span>接通</span></div>
                <div  class="num" @click="buttonSelect('bn0')"><span></span><span>0</span></div>
                <div  class="num" @click="buttonSelect('bngd')"><span></span><span>挂断</span></div>
              </div>
            </div>
          </div>
        </div>
        <div  class="bottom">
          <div  class="talk" @click="talk"></div>
<!--           :style="{'--url': url,}"-->
          <div  class="main">
            <div  class="middle">
              <div  class="mtop">
                <div  class="mscreen" >
                  <div  class="mshow" :class="parameter.mshow" v-if="parameter.doAudio">
<!--                   :class="{bluebg:blue,redbg:red}-->
                    <div  class="mcount">
                      <div  class="timer">
                        <div class="timer">
                          <div>00:{{seconds>=10?seconds:'0'+seconds}}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div  class="mclock" v-if="!parameter.doAudio">
                    <div  class="week">
                      <div class="weektime">
                        <div class="wdate">{{reDate()}}</div>
                        <div class="wtime"><span >{{HIS}}</span><span >{{reWeek()}}</span></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div  class="mbl"></div>
              </div>
              <div  class="mbottom">
                <div  class="b"><span  class="li grey"></span><span  class="tx">MP3</span><span  class="bb" @click="buttonSelect('bmp3')"></span></div>
                <div  class="b"><span  class="li grey"></span><span  class="tx">外线</span><span  class="bb" @click="buttonSelect('bwx')"></span></div>
                <div  class="b"><span  class="li grey" :class="parameter.mbottom&&parameter.mbottom.yjgb?parameter.mbottom.yjgb:''"></span><span  class="tx" style="scale: 0.7;">应急广播</span><span @click="buttonSelect('byjgb')"  class="bb"></span></div>
<!--                 :class="light1"-->
                <div  class="b"><span  class="li grey"></span><span  class="tx">录音</span><span  class="bb" @click="buttonSelect('bly')"></span></div>
<!--                 :class="light"-->
                <div  class="b"><span  class="li grey"></span><span  class="tx">自检</span><span  class="bb" @click="buttonSelect('bzj')"></span></div>
              </div>
            </div>
          </div>
          <div  class="work">
            <div  class="basic"><div  class="b1"><span >功放故障</span><span  class="bl" ></span><span  class="grey"></span></div>
              <div  class="b2"><span  class="grey"></span><span  style="scale: 0.7; text-align: center;">消音/背景</span><span  class="b2b"></span></div>
              <div  class="b3"><span  class="grey"></span><span  style="scale: 0.7;">手动</span><span  class="b3b"></span></div>
            </div>
            <div  class="wbs" >
              <div  class="wb" v-for="index in 20">
                <div  class="wnum" >{{index}}</div>
                <div  class="wlight">
                  <div ><span class="grey" :class="parameter.wlight&&parameter.wlight['work'+index]"></span><span >工作</span></div>
                  <div ><span class="grey" :class="parameter.wlight&&parameter.wlight['fault'+index]"></span><span >故障</span></div>
                </div>
                <div  class="wbutton" @click="buttonSelect('bwbutton'+index)"></div>
              </div>
            </div>
          </div>
        </div><!---->
      </div>
    </div>
<!--  疏散走道 报警按钮 -->
    <div v-if="parameter.evacuation">
      <div class="evacuation">
        <img :src="zoomOutImg" class="zoomOut" @click="onClose"/>
        <div class="evacuation-back" style="width: 100%;height: 100%;"></div>
        <div class="point" v-show="parameter.point"></div>
        <div class="anniu" @click="buttonSelect('anniu')"></div>
      </div>
    </div>
<!--  疏散走道  防火门控制器-总线控制盘doorController-->
    <div v-if="parameter.doorController">
      <div class="doorController">
        <img :src="zoomOutImg" class="zoomOut" @click="onClose"/>
        <img :src="require('@/assets/img/wei16/16-2-2.png')" style="width: 18.75rem;"/>
        <div class="one">
          <div class="light grey" :class="parameter.one&&parameter.one.run"></div>
          <div class="light grey" :class="parameter.one&&parameter.one.fankui"></div>
        </div>
        <div class="two">
          <div class="light grey" :class="parameter.two&&parameter.two.run"></div>
          <div class="light grey" :class="parameter.two&&parameter.two.fankui"></div>
        </div>
        <div class="start" @click="buttonSelect('ds')"></div>
      </div>
    </div>
<!--照明控制器-->
    <div v-if="parameter.illumination">
      <div class="illumination">
        <img :src="zoomOutImg" class="zoomOut" @click="onClose"/>
        <img :src="illuminationImg"/>
        <div class="lights">
          <div class="light">
            <span>主电工作</span>
            <span class=""></span>
          </div>
          <div class="light">
            <span>备电工作</span>
            <span class=""></span>
          </div>
          <div class="light">
            <span>应急</span>
            <span class="" :class="parameter.class&&parameter.class.yingji"></span>
          </div>
          <div class="light">
            <span>调试</span>
            <span class=""></span>
          </div>
          <div class="light">
            <span>手动允许</span>
            <span class=""></span>
          </div>
          <div class="light">
            <span>主电故障</span>
            <span class=""></span>
          </div>
          <div class="light">
            <span>备电故障</span>
            <span class=""></span>
          </div>
          <div class="light">
            <span>故障</span>
            <span class=""></span>
          </div>
          <div class="light">
            <span>消音</span>
            <span class=""></span>
          </div>
          <div class="light">
            <span>自动允许</span>
            <span class=""></span>
          </div>
        </div>
        <div class="start">
          <span @click="forceRun('force')"></span>
          <span class="force">强制启动</span>
        </div>
        <div class="pop"  :class="{hiden: !isShow}" v-if="parameter.illumination">
          <div class="notice">强制启动按钮已动作，是否启动应急？</div>
          <div class="reply"><span  @click="forceRun('yes')">YES</span><span  @click="forceRun('no')">NO</span></div>
        </div>
      </div>
    </div>
<!--    地下车库-防火卷帘控制器-->
    <div v-if="parameter.garage">
      <div class="garage">
        <img :src="zoomOutImg" class="zoomOut" @click="onClose"/>
        <img :src="require('@/assets/img/wei16/16-3-4.png')" style="width: 25rem;"/>
        <div class="lights">
          <div class="dianyuan light grey" :class="parameter.dian"></div>
          <div class="shang light grey" :class="parameter.shang"></div>
          <div class="xia light grey" :class="parameter.xia"></div>
          <div class="huojing light grey" :class="parameter.huojing"></div>
        </div>
      </div>
    </div>
<!--   地下车库-防火卷帘控制按钮 -->
    <div v-if="parameter.rollingShutter">
      <div class="rollingShutter">
        <img :src="zoomOutImg" class="zoomOut" @click="onClose"/>
        <img :src="require('@/assets/img/wei16/16-4-2.png')"/>
        <div class="down" @click="buttonSelect('rdown')"></div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import moment from "moment";
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    parameter: {},
    close: {
      type: Function,
    },
  },
  data() {
    return {
      doAudio:false,
      zoomOutImg:require('@/assets/img/zoomOut.png'),
      illuminationImg:require('@/assets/img/wei15/15-1-3.png'),
      keyCode: "",
      isShow: false,
      title:'',
      HI:"16:00",//当前时分
      YMD:'',
      HIS:'',
      YMDHI:'',
      seconds:0,
      yingji:'',//照明控制器里的参数
    };
  },
  created() {
    this.HI=moment().format("HH:mm");
    this.YMD=moment().format("YYYY-MM-DD");
    this.HIS=moment().format("HH:mm:ss");
  },
  mounted: function() {
    //刚进来就需要的参数
    if(this.parameter.defaultKey){
      this.keyCode=this.parameter.defaultKey;
    }
    if(!this.parameter.fireAlarm&&!this.parameter.broadcast){
      return false;
    }
    clearInterval();
    this.dateHI();
    this.YMDHI= moment().format("YYYY-MM-DD HH:mm");
  },
  methods: {
    show() {
      this.isShow = true;
    },
    onClose() {
      this.close && this.close();
      this.$emit('customPlay2', 'magnifying-xiao.mp3');
      clearInterval();
    },
    dateHI(){
      // if(!this.parameter.fireAlarm){
      //   return false;
      // }
      //时间显示
      this.HI=moment().format("HH:mm");
      this.YMD=moment().format("YYYY-MM-DD");
      this.HIS=moment().format("HH:mm:ss");
      //时间
      setInterval(() => {
        // 这里调用父组件传入的方法或者通过事件触发器将消息传递到父组件
        this.HI=moment().format("HH:mm");
        // this.YMD=moment().format("YYYY-MM-DD");
        this.HIS=moment().format("HH:mm:ss");
      }, 1000);
    },
    reTime() {
      return moment().format("YYYY-MM-DD HH:mm");
    },

    buttonSelect(parms) {
      console.log('buttonSelect22',parms,this.parameter)
      if(this.parameter[parms]){
        if(this.parameter[parms]['show']){
          this.keyCode = parms;
          if(this.parameter[parms]['title']){
            this.title =this.parameter[parms]['title'];
          }
        }
        console.log(this.parameter[parms]['up']&&(!this.parameter[parms]['submit']||(this.parameter[parms]['submit']&&(this.parameter[parms]['submit']['equal']===1&&this.parameter.branchKey===this.parameter[parms]['submit']['branch']||this.parameter[parms]['submit']['equal']===3))))
        if(this.parameter[parms]['up']&&(!this.parameter[parms]['submit']||(this.parameter[parms]['submit']&&(this.parameter[parms]['submit']['equal']===1&&this.parameter.branchKey===this.parameter[parms]['submit']['branch']||this.parameter[parms]['submit']['equal']===3)))){
          let arr=this.parameter[parms]['up'];
      console.log(arr)
          let new_=this.arrcover(arr,this.parameter)
          if(new_.defaultKey){
            this.keyCode=new_.defaultKey;
          }
          this.$set(this.parameter,new_)
        }
      }

      let submit=[];
      let update_=[];
      if(this.parameter[parms]&&this.parameter[parms]['submit']){
        submit=this.parameter[parms]['submit'];
      }
      if(this.parameter[parms]&&this.parameter[parms]['update']){
        console.log('subUpdate1',this.parameter[parms]['update'])
        update_= this.parameter[parms]['update'];
      }
      this.$emit('customOther',parms,submit,update_)

      this.$emit('customPlay2', 'keyboard.mp3');
    },

    arrcover(arr,new_){
      Object.keys(arr).forEach((k)=>{
        if(typeof arr[k] === 'object'){
          if(!new_[k]){
            new_[k]={};
          }
          this.arrcover(arr[k],new_[k])
        }
        else{
          new_[k]=arr[k];
        }
      })
      return new_;
    },

    // submit(){
    //   if (this.timer) {
    //     clearInterval(this.timer);
    //   }
    //
    //   this.red = false;
    //   this.light = 'grey'
    //   this.blue = true
    //   this.seconds = 0
    // },
    // one(){
    //   if(this.light1==='green'){
    //     this.light2 = 'green'
    //     this.$parent.play('broadcast.aac')
    //   }
    //
    //
    // },
    broadcast(){
      this.light1 = 'green'
      this.red = true

    },
    talk(){
      this.url='url("https://bankaoedu.com/files/xc/open.png") no-repeat'
      this.blue = true
      this.doAudio = true
    },

    reDate() {
      return moment().format("YYYY-MM-DD");
    },
    reWeek() {
      let weekday = moment().format("d");
      let weekdays = ['日', '一', '二', '三', '四', '五', '六'];
      return '星期' + weekdays[weekday];
    },
    forceRun(value){
      //照明控制器 强制启动
      if(value==='force'){
        this.isShow=true;
        this.yingji='';
      }
      else{
        this.isShow=false;
        if(value==='yes'){
          // this.yingji='red';
        }
        else{
          this.yingji='';
        }
      }
      this.buttonSelect(value);
    }
  },
};
</script>

<style lang="less" scoped>
@font-face {
  font-family: electronicFont;
  src: url(../../../assets/img/broadcast/DS-DIGIB-2.ttf);
}

.el-dialog__wrapper {
  position: absolute;
}
.hiden {
  display: none !important;
}
/deep/.el-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: calc(100% - 1.875rem);
  max-width: calc(100% - 1.875rem);
  background: transparent;
  box-shadow: none;
  width: auto;
}

/deep/.el-dialog .el-dialog__body {
  max-height: 100%;
  flex: 1;
  -ms-flex: 1 1 auto;
  overflow-y: hidden;
  overflow-x: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
//消控室-火灾报警控制器
.firescreen {
  position: relative;
  width: 75rem;
  height: 46.875rem;
  border: 0.625rem solid #fff;
  border-radius: 1.875rem;
  background-color: #e2e2e2;
  .zoomOut {
    width: 2.8125rem;
    height: 2.8125rem;
    cursor: pointer;
    position: absolute;
    right: 1.25rem;
    top: 1.25rem;
    z-index: 9999;
  }
  .buttons {
    position: absolute;
    top: 61.037313%;
    left: 46.86153%;
    width: 36.875rem;
    display: flex;
    flex-wrap: wrap;
    font-size: 0.875rem;
    justify-content: space-around;
    background-color: #e2e2e2;
    flex-flow: wrap;
    .button {
      width: 4.375rem;
      margin: 0 0.3125rem;
      height: 2.1875rem;
      line-height: 2.1875rem;
      text-align: center;
      margin-bottom: 0.9375rem;
      border-radius: 0.3125rem;
      box-shadow: 0 0.0625rem 0.0625rem #666,
      inset 0.0625rem 0.0625rem 0.0625rem #fff;
      cursor: pointer;
      font-weight: 500;
      border: 0.0625rem solid #444;
    }
  }

  // ===
  .light {
    display: none;
    position: absolute;
    background-color: #e2e2e2;
    display: flex;
    top: 15.951493%;
    left: 3.291879%;
    height: 45.522388%;
    width: 34.096825%;
    justify-content: space-between;
    align-items: center;
    font-size: 0.875rem;
    font-weight: 500;
    .red {
      background-color: #eb1919 !important;
    }
    .yellow{
      background-color: #f90 !important;
    }
    .green{
      background-color: #00ab22 !important;
    }
    .grey {
      background-color: #cecece;
    }
    .left {
      margin-right: 3.125rem;
    }
    .right {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }
    .item {
      display: flex;
      align-items: center;
      margin-bottom: 1rem;

      span:first-child {
        height: 0.5rem;
        width: 1rem;
        min-width: 1rem;
        display: inline-block;
        margin-right: 0.9375rem;
        border-radius: 0.125rem;
      }
      span:last-child {
        display: inline-block;
        width: 5rem;
        text-align: justify;
        height: 1.5625rem;
        line-height: 1.5625rem;
      }
    }
  }

  .time {
    top: 6.623134%;
    left: 3.591879%;
    height: 7.369403%;
    width: 11.868818%;
    position: absolute;
    background-color: #000;
    border-radius: 0.3125rem;
  }

  .show {
    position: absolute;
    top: 6.529851%;
    left: 47.494534%;
    height: 22.5rem;
    border: 0.1875rem solid #848484;
    box-sizing: border-box;
    border-radius: 0.625rem;
    background-color: #bebebe;
    .inner {
      width: calc(100% - 2.5rem);
      height: calc(100% - 2rem);
      margin: 1rem 1.25rem;
      background-color: #3f9ded;
      box-sizing: border-box;
      display: flex;
      .left {
        width: 25.9375rem;
        background-color: #eefcff;
        position: relative;
        .title {
          height: 1.875rem;
          background-color: #3f9ded;
          line-height: 1.875rem;
          color: #fff;
          box-sizing: border-box;
          padding: 0 0.625rem;
        }
        .main {
          .row {
            display: flex;
            align-items: center;
            margin: 0.5rem 0.5rem;
            font-size: 0.75rem;
            .cell {
              position: relative;
              margin-right: 0.75rem;
            }
          }
        }
        .title.linkage{
          position: absolute;
          top: 50%;
          z-index: 999;
          left: 0;
          right: 0;
          margin-top: -0.9375rem;
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          -webkit-box-align: center;
          -ms-flex-align: center;
          align-items: center;
          -webkit-box-pack: justify;
          -ms-flex-pack: justify;
          justify-content: space-between;
        }
        .main.linkage{
          position: absolute;
          //top: calc(50% + 1rem);
        }
        .linkage {
          //position: absolute;
          //top: 50%;
          z-index: 999;
          left: 0;
          right: 0;
          //margin-top: -0.9375rem;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .statics {
            margin-right: 1rem;
          }
        }
        .init{
          width: 100%;
          text-align: center;
          line-height: 16.25rem;
          font-size: 1rem;
          font-weight: 500;
        }
        .enter{
          padding: 0.5rem 0.5rem;
          font-size: 1rem;
        }
        .result{
          .row{
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            margin: 0 0.5rem;
            margin-top: 0.5rem;
            font-size: .75rem;
            .cell{
              position: relative;
              margin-right: 0.75rem;
            }
          }
        }
      }
      .right {
        position: relative;
        .content {
          background-color: #eefcff;
          min-width: 6.25rem;
          height: 13.75rem;
          margin-top: 1.875rem;
          margin-left: 0.875rem;
          box-sizing: border-box;
          padding: 0.625rem 0;
          .basic {
            font-size: 0.75rem;
            line-height: 1.25rem;
            padding: 0 0.3125rem;
          }
          .bg {
            background-color: #c4efff;
          }
        }
        .timer {
          position: absolute;
          left: 0.875rem;
          bottom: 3.4375rem;
          width: 6.25rem;
          z-index: 999;
          color: #fff;
        }
      }
    }
    .menu {
      position: absolute;
      height: 1.875rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #fff;
      background-color: #3f9ded;
      left: 1.25rem;
      bottom: 1rem;
      border-top: 1px solid #3885c8;
      right: 1.25rem;
      font-size: 0.75rem;
      .menu-f {
        margin: 0 0.9375rem;
      }
    }
  }

  .print {
    top: 68.623134%;
    left: 3.591879%;
    height: 24.369403%;
    width: 36.868818%;
    position: absolute;
    background: url(../../../assets/img/printbg.png);
    background-size: 100% auto;
    background-repeat: no-repeat;
    background-position: bottom;
    .paper {
      position: absolute;
      width: 14.125rem;
      height: 3.125rem;
      left: 9.0625rem;
      top: 2.8125rem;
      background: url(../../../assets/img/paper.png) no-repeat;
      background-size: 14.125rem 3.125rem;
      text-align: right;
      img {
        scale: 0.7;
        cursor: pointer;
      }
    }
  }

  .print-paper {
    position: absolute;
    top: 3.125rem;
    left: 12.5rem;
    width: 18.75rem;
    height: 31.25rem;
    background: url(../../../assets/img/paperpp.png) no-repeat;
    background-size: 18.75rem 31.25rem;
    img {
      position: absolute;
      scale: 0.7;
      right: 1.25rem;
      bottom: 1.25rem;
      cursor: pointer;
    }
    .print-list {
      padding: 2.5rem 1.875rem;
      .print-item {
        line-height: 1.5;
      }
    }
  }
}

.crayon-clock {
  width: 100%;
  font-family: Digit;
  color: red;
  text-align: center;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: 1.25rem;
}
// 漂移时间
.crayon-clock-date {
  font-size: 1.5rem;
}
.crayon-clock-time {
  letter-spacing: 0.05em;
  font-size: 3.75rem;
}
//消控室-消防联动
.bus {
  border: 0.5rem solid #fff;
  border-radius: 1.25rem;
  background-color: #edede5;
  position: relative;
  width: 75rem;
  height: 35rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 1.875rem 1.875rem;
  color: #000;
  .zoomOut {
    width: 2.8125rem;
    height: 2.8125rem;
    cursor: pointer;
    position: absolute;
    right: 1.25rem;
    top: 1.25rem;
  }
  .lights {
    width: 5rem;
    min-width: 5rem;
    position: relative;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    font-size: 0.75rem;
    .start span:first-child {
      width: 0.75rem;
      height: 0.75rem;
      display: inline-block;
      margin-right: 0.3125rem;
    }
    .type {
      position: relative;
      margin-top: 3.75rem;
      .maual {
        position: absolute;
        left: -2.5rem;
        width: 1.875rem;
        top: 0.625rem;
      }
      .mlight {
        display: flex;
        align-items: center;
        span:first-child {
          width: 0.75rem;
          height: 0.75rem;
          display: inline-block;
          margin-right: 0.3125rem;
        }
      }
    }
  }
  .lights .start,
  .lights {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }

  .operate {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    .head {
      display: flex;
      align-items: center;
      flex: 0 0 auto;
      height: 2.5rem;
      .th {
        display: flex;
        width: 10.3125rem;
        margin-right: 0.75rem;
        font-size: 0.75rem;
        div {
          margin-right: 0.25rem;
          margin-left: 0.25rem;
        }
      }
    }

    .list {
      display: flex;
      flex-grow: 1;
      .parent {
        width: 10.3125rem;
        margin-right: 0.75rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        box-sizing: border-box;
        border: 0.125rem solid #666;
        border-radius: 0.25rem;
        padding: 0.625rem 0;
        .child {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .row {
            display: flex;
            align-items: center;
          }
          .light {
            width: 0.75rem;
            height: 0.75rem;
            margin-left: 0.625rem;
            border-radius: 0.75rem;
          }
          .button {
            border: 1px solid #d78b00;
            width: 1rem;
            height: 1rem;
            margin-left: 1.25rem;
            border-radius: 0.1875rem;
            background-color: #d78b00;
            -webkit-box-shadow: inset 1px 1px 2px #fff;
            box-shadow: inset 1px 1px 2px #fff;
            cursor: pointer;
          }
          .text {
            text-align: center;
            font-size: 0.75rem;
            -webkit-box-flex: 1;
            -ms-flex: 1;
            flex: 1;
          }
        }
      }
    }
  }
  .green {
    background: url(../../../assets/img/green.png);
    background-size: 0.75rem 0.75rem;
  }
  .red {
    background: url(../../../assets/img/red.png);
    background-size: 0.75rem 0.75rem;
  }
  .grey {
    background: url(../../../assets/img/grey.png) no-repeat;
    background-size: 0.75rem 0.75rem;
  }
}
//消控室-广播
.broadcast {
  border: .5rem solid #fff;
  border-radius: 1.25rem;
  background-color: #edede5;
  position: relative;
  width: 75rem;
  height: 41.875rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 1.25rem 1.25rem;
  color: #000;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  .zoomOut {
    cursor: pointer;
    position: absolute;
    right: 1.25rem;
    top: 1.25rem;
  }
  .grey{
    background: url(../../../assets/img/grey.png) no-repeat;
    background-size: 0.625rem 0.625rem;
  }
  .green{
    background: url(../../../assets/img/green.png) no-repeat;
    background-size: 0.625rem 0.625rem;
  }

  .yellow {
    background-image: url(../../../assets/img/yellow.png);
    background-size: .625rem .625rem
  }
  .red{
    background: url(../../../assets/img/red.png) no-repeat;
    background-size: 0.625rem 0.625rem;
  }
  .bling-limit{
    -webkit-animation: limit 1s forwards;
    animation: limit 1s forwards;
    -webkit-animation-iteration-count: 3;
    animation-iteration-count: 3;
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards
  }

  @-webkit-keyframes limit {
    50% {
      opacity: .4
    }
  }

  @keyframes limit {
    50% {
      opacity: .4
    }
  }

  @-webkit-keyframes fbling {
    50% {
      opacity: .5
    }
  }

  @keyframes fbling {
    50% {
      opacity: .5
    }
  }


  .choose {
    position: absolute;
    left: 3.125rem;
    top: 1.875rem;
    background-color: #fff;
    border-radius: .625rem;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
  }
  .choose .title{
    background-color: #0080ff;
    border-radius: .625rem .625rem 0 0;
    padding: .625rem;
    font-size: 1rem;
    color: #fff;
  }
  .choose .options {
    padding: .625rem;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    font-size: 1rem;
  }
  .choose .options span {
    display: inline-block;
    padding: .625rem 0;
    cursor: pointer;
  }

  .top {
    width: 100%;
    height: 19.0625rem;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
  .top .tel {
    width: 60%;
    height: 100%;
    position: relative;
  }
  .top .tel .tel-bottom {
    position: absolute;
    top: 32.340944%;
    left: 20.682671%;
    height: 35.362253%;
    width: 58.354607%;
    background-color: #000;
    border-radius: .75rem;
    -webkit-box-shadow: inset 0 0 0.5rem #fff;
    box-shadow: inset 0 0 0.5rem #fff;
  }
  .top .tel .tel-bottom .phone {
    position: absolute;
    width: 100%;
    height: 100%;
    background: url(../../../assets/img/broadcast/phone-red.png) no-repeat;
    background-size: 25rem auto;
    background-position: 50%;
    -webkit-transition: -webkit-transform .3s linear;
    transition: -webkit-transform .3s linear;
    transition: transform .3s linear;
    transition: transform .3s linear, -webkit-transform .3s linear;
    -webkit-transform-origin: left bottom;
    transform-origin: left bottom;
  }
  .top .tel .tel-bottom .phone.open{
    -webkit-transform: rotate(10deg);
    transform: rotate(10deg);
  }
  .top .dial {
    width: 40%;
    height: 100%;
    background-color: #7f8ba5;
    border-radius: .9375rem;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 1rem;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
  }
  .top .dial .left {
    width: 13.75rem;
    height: 17.0625rem;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
  }
  .top .dial .left .screen {
    background-color: #8ede6d;
    height: 8.75rem;
    width: 100%;
    max-height: 8.75rem;
    border-radius: .625rem;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
  .top .dial .left .screen .sclock {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    margin-top: 1.25rem;
  }
  .top .dial .left .screen .systemstate {
    text-align: center;
    font-size: 1.125rem;
    margin-top: .625rem;
  }
  .top .dial .left .screen .enter{
    background-color: #000;
    width: 7.5rem;
    height: 3.75rem;
    margin: 1.875rem auto;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #fff;
    text-align: center;
    padding: 0.625rem 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
  }
  .top .dial .left .screen .menu{
    font-size: 1.125rem;
    font-weight: 500;
    margin: 1.5625rem auto;
    text-align: center;
    .menu-box{
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -ms-flex-wrap: wrap;
      flex-wrap: wrap;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      span{
        width: 40%;
        //margin-top: 0.3125rem;
      }
      span:first-child{
        background-color: #000;
        color: #fff;
      }
    }
  }
  .top .dial .left .screen .fault{
    font-size: 1.125rem;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    text-align: center;
    margin: 1.875rem 0;
    font-weight: 500;
  }
  .top .dial .left .screen .ready{
    font-size: 1.25rem;
    font-weight: 500;
    text-align: center;
    margin-top: 3.125rem;
  }
  .top .dial .left .screen .hujiao{
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    margin-top: 0.625rem;
    margin-left: 1.25rem;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    font-weight: 500;
    span{
      width: 45%;
      margin-top: 0.625rem;
    }
  }
  .top .dial .left .buttons {
    height: 8.125rem;
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: .75rem 0;
    background-color: #bac4bc;
    border-radius: .625rem;
    margin-top: 1.25rem;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
  }
  .top .dial .left .buttons .btn {
    width: 4.5625rem;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    font-size: .75rem;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
  }
  .top .dial .left .buttons .btn span:first-child {
    width: 1.75rem;
    height: 1.75rem;
    border-radius: 1.75rem;
    background-color: #f8f6ea;
    -webkit-box-shadow: 0.0625rem 0.0625rem 0.25rem #888;
    box-shadow: 0.0625rem 0.0625rem 0.25rem #888;
    margin-bottom: .5rem;
  }
  .top .dial .right {
    width: 11.875rem;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
  }
  .top .dial .right .lights .light, .top .dial .right .lights {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
  .top .dial .right .lights {
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    background-color: #bac4bc;
    border-radius: .625rem;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: .625rem;
  }
  .top .dial .right .lights .light {
    width: 2.625rem;
    font-size: .625rem;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    height: 2.5rem;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
  }
  .top .dial .right .lights .light, .top .dial .right .lights {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
  .top .dial .right .lights .light span:first-child {
    width: .625rem;
    height: .625rem;
    border-radius: .625rem;
    margin-bottom: .3125rem;
  }
  .top .dial .right .nums {
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    background-color: #bac4bc;
    border-radius: .625rem;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: .625rem;
    margin-top: 1.25rem;
  }
  .top .dial .right .nums .num {
    width: 3.5rem;
    font-size: .625rem;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
  }
  .top .dial .right .nums .num, .top .dial .right .nums {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
  .top .dial .right .nums .num, .top .dial .right .nums {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
  .top .dial .right .nums .num span:first-child {
    width: 1rem;
    height: 1rem;
    border-radius: 1rem;
    background-color: #f8f6ea;
    -webkit-box-shadow: 0.0625rem 0.0625rem 0.25rem #888;
    box-shadow: 0.0625rem 0.0625rem 0.25rem #888;
    margin-bottom: .1875rem;
  }

  .bottom {
    width: 100%;
    height: 19.0625rem;
    margin-top: 1.25rem;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
  .bottom .talk {
    width: 8.125rem;
    height: 100%;
    background: url(../../../assets/img/broadcast/closed.png);
    background-size: 100% auto;
    background-position: 50%;
  }
  .bottom .main .middle, .bottom .main {
    height: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
  }
  .bottom .main {
    width: 18.75rem;
    background-color: #f8f6ea;
    border-radius: .625rem;
    -webkit-box-shadow: 0.125rem 0.125rem 0.125rem #666;
    box-shadow: 0.125rem 0.125rem 0.125rem #666;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
  }
  .bottom .main .middle {
    width: 12.5rem;
    padding: .625rem 0;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
  }
  .bottom .main .middle, .bottom .main {
    height: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
  }
  .bottom .main .middle .mtop {
    background-color: #252730;
    border-radius: .9375rem;
    height: 10.625rem;
  }
  .bottom .main .middle .mtop .mscreen {
    height: 6.25rem;
    margin: .625rem;
    border-radius: .9375rem;
    background-color: #0080ff;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
  .bottom .main .middle .mtop .mbl {
    background: url(../../../assets/img/broadcast/audioplay.png) no-repeat;
    height: 2.5rem;
    background-size: auto 2.375rem;
    background-position: 50%;
  }
  .bottom .main .middle .mbottom .b, .bottom .main .middle .mbottom {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
  }
  .bottom .main .middle .mbottom {
    margin-top: 1.25rem;
    height: 4.6875rem;
  }
  .bottom .main .middle .mbottom .b {
    background-color: #252730;
    width: 1.875rem;
    height: 100%;
    border-radius: .3125rem;
    color: #fff;
    font-size: .6875rem;
    text-align: center;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: .5rem 0;
  }
  .bottom .main .middle .mbottom .b .li {
    width: .625rem;
    height: .625rem;
    display: inline-block;
  }
  .bottom .main .middle .mbottom .b .bb {
    width: .875rem;
    height: .875rem;
    border-radius: .875rem;
    background-color: #f8f6ea;
    cursor: pointer;
  }
  .bottom .work .basic, .bottom .work {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
  .bottom .work {
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    height: 100%;
    background-color: #f8f6ea;
    border-radius: .625rem;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-box-shadow: 0.125rem 0.125rem 0.125rem #666;
    box-shadow: 0.125rem 0.125rem 0.125rem #666;
    margin-left: 1.25rem;
    padding: .625rem 1rem;
  }
  .bottom .work .basic {
    width: 5rem;
    margin-right: .625rem;
    min-width: 5rem;
    font-size: .75rem;
    height: 14.375rem;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
  }
  .bottom .work .basic, .bottom .work {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
  .bottom .work .basic div {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
  }
  .bottom .work .basic, .bottom .work .basic div {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
  }
  .bottom .work .basic .b1 .bl {
    width: .625rem;
    height: .625rem;
    display: inline-block;
    margin-top: .5rem;
    position: relative;
  }
  .bottom .work .basic .b2 {
    border: .0625rem solid #333;
    border-radius: .5rem;
    height: 5rem;
    width: 3.75rem;
  }
  .bottom .work .basic div {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
  }
  .bottom .work .basic .b2 .b2b {
    width: 1rem;
    height: 1rem;
    border-radius: 1rem;
    background-color: #d9d3cd;
    -webkit-box-shadow: 0.0625rem 0.0625rem 0.0625rem #999;
    box-shadow: 0.0625rem 0.0625rem 0.0625rem #999;
    margin-top: .5rem;
  }
  .bottom .work .basic .b3 {
    height: 5rem;
    width: 3.75rem;
    border: .0625rem solid #333;
    border-radius: .5rem;
  }
  .bottom .work .basic .grey {
    width: .625rem;
    height: .625rem;
    display: inline-block;
    margin-bottom: .5rem;
  }
  .bottom .work .basic .b3 .b3b {
    width: 1rem;
    height: 1rem;
    border-radius: 1rem;
    background-color: #d9d3cd;
    -webkit-box-shadow: 0.0625rem 0.0625rem 0.0625rem #999;
    box-shadow: 0.0625rem 0.0625rem 0.0625rem #999;
    margin-top: .5rem;
  }
  .bottom .work .wbs {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
  }
  .bottom .work .wbs .wb {
    width: 6.875rem;
    border: .0625rem solid #333;
    border-radius: .5rem;
    margin: .3125rem 0;
    position: relative;
    height: 3.125rem;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    font-size: .75rem;
  }
  .bottom .work .wbs .wb .wnum {
    position: absolute;
    left: 0;
    top: 0;
    padding: .1875rem .375rem;
    border: .0625rem solid #333;
    border-radius: .5rem 0 .5rem 0;
    border-left: none;
    border-top: none;
  }
  .bottom .work .wbs .wb .wlight {
    margin-left: .9375rem;
  }
  .bottom .work .wbs .wb .wlight div {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
  .bottom .work .wbs .wb .wlight div span:first-child {
    width: .625rem;
    height: .625rem;
    margin-right: .25rem;
  }
  .bottom .work .wbs .wb .wlight div span:last-child {
    scale: .9;
  }
  .bottom .work .wbs .wb .wlight div {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
  .bottom .work .wbs .wb .wlight div span:first-child {
    width: .625rem;
    height: .625rem;
    margin-right: .25rem;
  }
  .bottom .work .wbs .wb .wlight div span:last-child {
    scale: .9;
  }
  .bottom .work .wbs .wb .wbutton {
    width: 1.25rem;
    height: 1.25rem;
    border-radius: 1.25rem;
    background-color: #d9d3cd;
    -webkit-box-shadow: 0.0625rem 0.0625rem 0.0625rem #999;
    box-shadow: 0.0625rem 0.0625rem 0.0625rem #999;
    margin-left: .625rem;
    cursor: pointer;
  }
  .bottom .main .middle .mtop .mscreen .mclock {
    height: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
  }
  .bottom .main .middle .mtop .mscreen .mshow.bluebg{
    background: url(../../../assets/img/broadcast/bluepaly.png) no-repeat;
    background-size: 100% 100%;
  }
  .bottom .main .middle .mtop .mscreen .mshow.redbg{
    background: url(../../../assets/img/broadcast/redplay.png) no-repeat;
    background-size: 100% 100%;
  }
  .bottom .main .middle .mtop .mscreen .mshow {
    height: 100%;
    position: relative;
    border-radius: .625rem;
  }
  .bottom .main .middle .mtop .mscreen .mshow .mcount {
    width: 5rem;
    height: 1.875rem;
    position: absolute;
    left: 3.125rem;
    top: 1.25rem;
    font-family: electronicFont;
    font-size: 1.555rem;
    letter-spacing: .125rem;
  }

  .week .datetime {
    font-size: 1.25rem;
    font-family: Arial, Helvetica, sans-serif;
    font-weight: 400;
  }
  .week .weektime .wdate {
    font-size: 1.25rem;
    margin-bottom: .625rem;
  }
  .week .weektime {
    text-align: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
}
//疏散走道
.evacuation{
  border-radius: 1.25rem;
  background-color: #edede5;
  position: relative;
  width: 35rem;
  height: 40rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #000;
  .zoomOut{
    right: 1rem;
    top: 1rem;
  }
  .evacuation-back{
    background: url("../../../assets/img/wei8/8-1-4.png") no-repeat 0 0 fixed;
    background-size:cover;
  }
  .point{
    position: absolute;
    border: 0.4rem solid red;
    border-radius: 1rem;
    top: 13.58rem;
    left: 10.75rem;
  }
  .anniu{
    position: absolute;
    border: 1.5rem solid #18161c;
    border-radius: 1.5rem;
    top: 16.4rem;
    left: 16.1em;
    cursor:pointer;
  }
}
//照明控制器
.illumination{
  position: relative;
  .zoomOut {
    width: 2.8125rem;
    height: 2.8125rem;
    cursor: pointer;
    position: absolute;
    right: 1.25rem;
    top: 1.25rem;
  }
  //.light-system .lights .light[data-v-b2ccce52], .light-system .lights[data-v-b2ccce52]
  .lights{
    position: absolute;
    top: 82.4%;
    left: 36.9%;
    height: 13.1%;
    width: 20.5%;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    background-color: #dedbdb;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    .red{
      background-color: #eb1919 !important;
    }
    .light{
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -ms-flex-direction: column;
      flex-direction: column;
      width: 20%;
      span:first-child{
        font-size: 0.6rem;
        font-weight: 600;
        display: inline-block;
        width: 3.125rem;
        text-align: center;
        color: #000;
      }
      span:last-child{
        width: 0.375rem;
        height: 0.375rem;
        border-radius: 0.375rem;
        background-color: #cac8c9;
        -webkit-box-shadow: 1px 1px 2px #333;
        box-shadow: 1px 1px 2px #333;
      }
    }
  }
  .start{
    position: absolute;
    top: 87.51362%;
    left: 59.3%;
    height: 7.168459%;
    width: 4.7%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    background-color: #dedbdb;
    span:first-child{
      display: block;
      background-color: #c52327;
      height: 5rem;
      border-radius: 0.1875rem;
      cursor: pointer;
    }
    .force{
      font-size: 0.6rem;
      width: 3.125rem;
      font-weight: 600;
      color: #000;
      text-align: center;
    }
  }
  .pop{
    position: absolute;
    top: 27.4%;
    left: 39.1%;
    height: 15.4%;
    width: 33%;
    border: 1px solid #000;
    border-radius: 0.3125rem;
    background-color: #f2f2f2;
    .notice{
      margin: 1rem 1.875rem;
      display: -webkit-box;
      display: -ms-flexbox;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      color: red;
      font-weight: 600;
      text-align: center;
    }
    .reply{
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      span:first-child{
        width: 5rem;
        background-color: #f2f2f2;
        -webkit-box-shadow: 0.125rem 0.125rem 0 #222, inset 0.125rem 0.125rem 0 #fff;
        box-shadow: 0.125rem 0.125rem 0 #222, inset 0.125rem 0.125rem 0 #fff;
        text-align: center;
        padding: .3125rem 0;
        cursor: pointer;
        color: red;
        font-weight: 600;
        margin-right: 8%;
      }
      span:last-child{
        width: 5rem;
        background-color: #f2f2f2;
        -webkit-box-shadow: 0.125rem 0.125rem 0 #222, inset 0.125rem 0.125rem 0 #fff;
        box-shadow: 0.125rem 0.125rem 0 #222, inset 0.125rem 0.125rem 0 #fff;
        text-align: center;
        padding: .3125rem 0;
        cursor: pointer;
        color: red;
        font-weight: 600;
      }
    }
  }
}
//防火门控制器-总线控制盘
.doorController{
  .zoomOut{
    top: 1rem;
    right: 1rem;
  }
  position: relative;
  .one{
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    position: absolute;
    top: 5.6%;
    left: 7.977208%;
    height: 3.28%;
    width: 15.242165%;
  }
  .light{
    height: 1.125rem;
    width: 1.125rem;
    background-color: transparent;
    border-radius: 1.25rem;
  }
  .two{
    position: absolute;
    top: 15.12%;
    left: 7.977208%;
    height: 3.52%;
    width: 15.242165%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
  }
  .light{
    height: 1.125rem;
    width: 1.125rem;
    background-color: transparent;
    border-radius: 1.25rem;
  }
  .start{
    position: absolute;
    top: 4.48%;
    left: 32.905983%;
    height: 5.36%;
    width: 9.401709%;
    border-radius: 100%;
    cursor: pointer;
  }
  .red{
    background-color: red;
  }
}
.garage{
  position: relative;
  .zoomOut{
    top: 1rem;
    right: 1rem;
  }
  .lights{
    position: absolute;
    top: 82.513821%;
    left: 9.678159%;
    height: 2.811821%;
    width: 32.149184%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #5297b6;
    .light{
      width: .875rem;
      height: .875rem;
      border-radius: .875rem;
    }
  }
  .grey{
    background-color: #d8d8d8;
  }
  .red {
    background-color: #eb1919;
  }
}
.rollingShutter{
  position: relative;
  .zoomOut{
    top: 1rem;
    right: 1rem;
  }
  .down{
    position: absolute;
    left: 24.4%;
    top: 61.2%;
    width: 20%;
    height: 12%;
    border-radius: 100%;
  }
}
</style>
